export const opdNavigation = {
    OPD_APPOINTMENT_NAVIGATE: "/OPD/new-appointment/patient-appointment",
    OPD_PATIENT_NAVIGATE:"/OPD/patient/patient-encounter",
    ADT_NAVIGATE:"../adt/admission-form-new",
    DayCare_NAVIGATE:"/daycare/admission-form",
    REPORT_NAVIGATE:"#/Dashboard/pdfViewer"
}